import {RelationDetailRes, RelationTypeRes,} from "../relation.contract";
import {Commtype} from '../../../../enums';
import {ContactPersonDetailRes} from '../user.contract';
import {Type} from 'class-transformer';
import {StatusDetailRes} from '../status.contract';
import {FileUploadRes} from '@yasc/yasc-material-components';

export class NoteDetailRes {
    id!: number;
    noteId!: string;
    name!: string;
    text!: string
    @Type(() => FileUploadRes)
    attachment!: FileUploadRes[]
    @Type(() => RelationTypeRes)
    relations: RelationDetailRes[] = [];
    communicationType!: Commtype;
    @Type(() => Date)
    communicatedOn!: Date;
    @Type(() => ContactPersonDetailRes)
    contactPerson!: ContactPersonDetailRes;
    @Type(() => StatusDetailRes)
    createdForStatus!: StatusDetailRes

    constructor() {
    }

    public addNewRelation(relation: RelationDetailRes) {
        this.relations.push(relation)
    }

    public toUpdate():NoteUpdateReq{
        let communicatedOn = new Date(new Date(this.communicatedOn).setUTCHours(24))

        return new NoteUpdateReq({
            id: this.id,
            title: this.name,
            text: this.text,
            type: this.communicationType,
            date: communicatedOn.toISOString(),
            contactPersonId: this.contactPerson.id,
            createdForStatusId: this.createdForStatus.id,
        })
    }
}


export class NoteCreateReq {
    title!: string;
    text?: string;
    type!: Commtype;
    communicatedOn!: any;
    communicationPartnerId!: number;
    companyId!: number;
    trackerId!: number;
    attachments: string[] = [];
    createdForStatusId!: number

    constructor(note?: NoteDetailRes) {
        if (note != undefined) {
            this.title = note.name
            this.text = note.text
            if (note.attachment !== undefined)
                this.attachments = note.attachment.map(x => x.id)
            this.type = note.communicationType;
            if (note.contactPerson != undefined)
                this.communicationPartnerId = note.contactPerson.id
            this.communicatedOn = Date.now().toLocaleString()
            this.createdForStatusId = note.createdForStatus.id
        }
    }
}

export class NoteUpdateReq {
    id!:number;
    title?: string;
    text?: string;
    type?: Commtype;
    trackerId?: number;
    date?:string;
    contactPersonId?:number;
    createdForStatusId?:number;

    constructor(note:Partial<NoteUpdateReq>) {
        this.id = note.id!;
        this.title = note.title;
        this.text = note.text;
        this.type = note.type;
        this.trackerId = note.trackerId;
        this.date = note.date;
        this.contactPersonId = note.contactPersonId;
        this.createdForStatusId = note.createdForStatusId;
    }
}